import {
  buildRequestedParameterIntents,
  type RequestedParameterBindingKind,
  type RequestedParameterDestination,
  type RequestedParameterIntentInput,
} from '../../../shared/api/grpc/requestedParameterIntent';
import { buildMappedProjectParameterBindingGroups } from '../../../shared/lib/hooks/parameterAddition/mappedProjectParameterModePolicy';

export interface QuickFillParameterIntentGroup {
  parameterNames?: readonly string[] | null;
  destination?: RequestedParameterDestination | null;
  bindingKind?: RequestedParameterBindingKind | null;
}

export interface MappedQuickFillParameterIntentGroup extends QuickFillParameterIntentGroup {
  parameterNames: string[];
  destination: 'project';
  bindingKind: RequestedParameterBindingKind;
}

/**
 * Only configuration-backed columns receive an intent. Manually configured
 * columns stay on the connector's broad compatibility path.
 */
export function buildQuickFillRequestedParameterIntents(
  groups: readonly QuickFillParameterIntentGroup[]
): RequestedParameterIntentInput[] {
  return buildRequestedParameterIntents(groups);
}

export function buildMappedQuickFillParameterIntentGroups(
  parameterNames: string[],
  preferredBindingKind: RequestedParameterBindingKind
): MappedQuickFillParameterIntentGroup[] {
  return buildMappedProjectParameterBindingGroups({
    parameterNames,
    preferredBindingKind,
  }).map((group) => ({
    ...group,
    destination: 'project',
  }));
}
